import FieldProject from "../../../generic/entity/project/project";
import FieldConfig from "../../../../fields3/proto/field-config";
import FieldTaskParent_CSVImportPreview from "./render/csv-import-preview";
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module";
import {EntityType} from "../../../../gd/const/item"
import ItemModelV2 from "../../../../model2/item2/item-model"
import GroupBy from "../../../../gd/manager/group-by/group-by-model"

export default class FieldTaskParent extends FieldProject {


    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel      = "Task project";
        this.icon           = 'ii5-project';

        this.variableName   = '{TASK-PROJECT}'

        this.parentsFor = _.get(config,'parentsFor', EntityType.TASK)

        this.renderComponents.csvImportPreview  = FieldTaskParent_CSVImportPreview
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        const projectId = super.normalizeFromCSVValue(value, module)

        // workspace can't be task parent (no tasks in workspace root)
        return gd.spaces.workspaces.getByProjectId(projectId) ? null : projectId
    }

    // used to get value from itemModel for grouping
    groupItemValue(itemModel: ItemModelV2, groupBy: GroupBy) {
        if (itemModel.projectItem) {
            return itemModel.projectItem.projectId
        } else {
            return super.groupItemValue(itemModel, groupBy)
        }
    }
}
